import { motion } from "framer-motion";
import {
  CheckCircle,
  XCircle,
  FileText,
  Hourglass,
  Clock,
  Inbox,
} from "lucide-react";
import DynamicIcon from "../Form/FormFields/DynamicIcon";
interface DashboardCountProps {
  data: {
    title: string;
    count: number | string;
    icon: JSX.Element;
    color: string;
  }[];
}

// Function to dynamically map data keys to icons and colors
const getDynamicConfig = (key: string) => {
  const configMap: { [key: string]: { icon: JSX.Element; color: string } } = {
    opening_balance: {
      icon: (
        <DynamicIcon name="ShieldCheck" className={`w-5 h-5 text-[#6993FF]`} />
      ),
      color:
        "bg-gradient-to-r from-[#f5f7e4] to-[#f1fa77] text-[#4B5563] border-l-4 border-yellow-400",
    },
    received: {
      icon: (
        <DynamicIcon name="LibraryBig" className={`w-5 h-5 text-[#6993FF]`} />
      ),
      color:
        "bg-gradient-to-r from-[#DFF0FF] to-[#EEF7FF] text-[#4B5563] border-l-4 border-blue-400",
    },
    total_received: {
      icon: (
        <DynamicIcon name="ScanQrCode" className={`w-5 h-5 text-[#6993FF]`} />
      ),
      color:
        "bg-gradient-to-r from-[#EAF2FF] to-[#D7E5FF] text-[#4B5563] border-l-4 border-blue-600",
    },
    approved: {
      icon: (
        <DynamicIcon name="LibraryBig" className={`w-5 h-5 text-[#6993FF]`} />
      ),
      color:
        "bg-gradient-to-r from-[#DBFEEB] to-[#E6FDED] text-[#4B5563] border-l-4 border-green-400",
    },
    rejected: {
      icon: (
        <DynamicIcon
          name="ChartNoAxesColumn"
          className={`w-5 h-5 text-[#6993FF]`}
        />
      ),
      color:
        "bg-gradient-to-r from-[#FFE4E2] to-[#FFF6F5] text-[#4B5563] border-l-4 border-red-400",
    },
    pending: {
      icon: (
        <DynamicIcon name="LayoutGrid" className={`w-5 h-5 text-[#6993FF]`} />
      ),
      color:
        "bg-gradient-to-r from-[#FFF3E0] to-[#FEE7C3] text-[#4B5563] border-l-4 border-orange-400",
    },
  };

  return (
    configMap[key] || {
      icon: (
        <FileText className="bg-[#E5E7EB] p-2 rounded-lg shadow text-[#6B7280] w-9 h-9" />
      ),
      color: "bg-gray-200 text-gray-700 border-l-4 border-gray-400",
    }
  );
};

// Convert data dynamically
const transformData = (rawData: any) => {
  return Object.entries(rawData?.[0] || {}).map(([key, value]) => {
    const { icon, color } = getDynamicConfig(key);
    return {
      title: key
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase()), // Convert key to Title Case
      count: value == null ? 0 : value,
      icon,
      color,
    };
  });
};

// Custom Card Component
const DashboardCount: React.FC<{ data: any }> = ({ data }) => {


  const formatNumberWithCommas = (value: any) => {
    const locale = "en-IN";
    if (value === null || value === undefined) return value;
    if (typeof value === "number") return value.toLocaleString(locale);
    if (typeof value === "string") {
      const cleaned = value.replace(/,/g, "");
      if (/^-?\d+(?:\.\d+)?$/.test(cleaned)) {
        const num = Number(cleaned);
        if (!Number.isNaN(num)) return num.toLocaleString(locale);
      }
    }
    return value;
  };

  const processedData = transformData(data);

  return (
    <div
      // className={`grid   ${
      //   data && Object.keys(data?.[0])?.length > 3 ? `grid-cols-2` : `grid-cols-1`
      //   }

            className={`grid ${
         `grid-cols-2`
        }

        gap-x-4 gap-y-4 mt-4`}
    >
      {processedData.map((item, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.2 }}
        >
          <div className="space-y-3">
            <div
              className={`flex items-center justify-between p-4 rounded-lg ${item.color}`}
            >
              <div>
                <p className="text-sm font-medium">{item.title}</p>
                <p className="text-xl font-bold">{formatNumberWithCommas(item.count)}</p>
              </div>
              <div>{item.icon}</div>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default DashboardCount
